'use client';

import GlobalError from '@components/views/error/GlobalError';

export default function ErrorPage({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return <GlobalError error={error} />;
}
